const joinWithBr = (items = []) => items.filter(Boolean).join(' <br /> ') || null

export { joinWithBr }
